import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { PageHeader, Loading, ErrorState, EmptyState, StatusPill } from "@/components/Bits";
import { dmyTime, titleize } from "@/lib/format";

export default function OwnerAudit() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/owner/audit", { params: { limit: 200 } })
      .then(({ data }) => setItems(data.items)).catch((e) => setError(apiError(e)));
  }, []);

  if (error) return <ErrorState message={error} />;
  if (!items) return <Loading label="Loading audit log…" />;

  return (
    <div data-testid="owner-audit-page">
      <PageHeader overline="Compliance" title="Platform audit log"
        subtitle="Logins, business creation, permission changes, financial reversals, exports and admin resets." />
      <div className="panel overflow-hidden">
        {items.length === 0 ? <EmptyState title="No audit events yet" testid="audit-empty" /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-slate-50 text-left">
                <tr className="text-[11px] uppercase tracking-wider text-slate-500">
                  <th className="px-6 py-4 font-semibold">When</th>
                  <th className="px-6 py-4 font-semibold">Action</th>
                  <th className="px-6 py-4 font-semibold">Actor</th>
                  <th className="px-6 py-4 font-semibold">Entity</th>
                  <th className="px-6 py-4 font-semibold">Result</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {items.map((a) => (
                  <tr key={a.log_id}>
                    <td className="px-6 py-4 text-slate-500 whitespace-nowrap">{dmyTime(a.created_at)}</td>
                    <td className="px-6 py-4 font-medium text-slate-900">{titleize(a.action)}</td>
                    <td className="px-6 py-4 text-slate-600">{a.user_email || "system"}</td>
                    <td className="px-6 py-4 text-slate-500">{a.entity || "—"}</td>
                    <td className="px-6 py-4"><StatusPill status={a.result} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
